import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Stack,
  FormControl,
  Divider,
  Paper,
  IconButton,
} from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { bottomButton } from "../../common/styles";
import { PHARMACY_INFORMATION } from "../../routes/path";
import {
  setPharmacySelected,
  setApplyPrescriptionEnterType,
} from "../../store/actions/prescription";
import { getPharmacy } from "../../server/axios";
//共通コンポーネント
import { Header, Pulldown, MainColorButton, Loading } from "../../components";
import store from "../../store";
// redux
import { closeWindow } from "../../utils/getLineProfile";
/**
 * 薬局一覧
 * @returns
 */
const PharmacyList = () => {
  const navigate = useNavigate();

  const [loadingOpen, setLoadingOpen] = useState(false);

  const [data, setData] = useState([]);
  const [prefecture, setPrefecture] = useState("");
  const [prefectureArray, setPrefectureArray] = useState([]);

  const selectLineInfo = (state) => state.prescription.lineInfo;
  const lineInfo = selectLineInfo(store.getState());

  const handlePrefectureChange = (value) => {
    setPrefecture(value);
  };

  const getData = () => {
    getPharmacy({ mode: "3", prefecture: prefecture, lineId: lineInfo.lineId }).then((res) => {
      if (res.data.target) {
        setData(res.data.target);
      }
      setLoadingOpen(false);
    });
  };

  const getPrefectureArray = () => {
    getPharmacy({ mode: "4", liffId: lineInfo.liffId }).then((res) => {
      if (res.data.prefecture) {
        setPrefecture(res.data.prefecture[0]);
        setPrefectureArray(res.data.prefecture);
      }
      setLoadingOpen(false);
    });
  };

  // 初期化
  useEffect(() => {
    setLoadingOpen(true);
    getPrefectureArray();
  }, []);

  // 都道府県変更
  useEffect(() => {
    if (prefecture) {
      setLoadingOpen(true);
      getData();
    }
  }, [prefecture]);

  const handleClick = (item) => {
    let selectedRows = item;
    store.dispatch(
      setPharmacySelected({
        selectedRows,
      })
    );
    store.dispatch(setApplyPrescriptionEnterType(1));
    navigate(PHARMACY_INFORMATION);
  };

  return (
    <>
      <Loading open={loadingOpen} />
      <Header title="薬局一覧" />
      <Stack
        height="76vh"
        marginTop="9vh"
        marginLeft="auto"
        marginRight="auto"
        spacing="6%"
      >
        <Stack spacing="2%" paddingLeft="3%">
          <Stack direction="row" alignItems="center">
            <Box width="30%">
              <Typography>
                <strong>都道府県</strong>
              </Typography>
            </Box>
            <Box width="40%">
              <FormControl fullWidth>
                <Pulldown
                  size="small"
                  withLabel={false}
                  withMenuProps={true}
                  items={prefectureArray.map((item) => {
                    return { id: item, value: item, label: item };
                  })}
                  value={prefecture}
                  setValue={handlePrefectureChange}
                />
              </FormControl>
            </Box>
          </Stack>
        </Stack>
        <Paper
          elevation={0}
          variant="outlined"
          sx={{ height: "60vh", overflowY: "scroll" }}
        >
          <Stack divider={<Divider />}>
            {data && data.length > 0 ? (
              data.map((item, index) => (
                <Stack
                  key={index}
                  spacing="2%"
                  direction="row"
                  sx={{ paddingX: "3%", paddingY: "1%" }}
                  onClick={() => handleClick(item)}
                >
                  <Stack width="90%">
                    <Stack direction="row" spacing="2%" alignItems="center">
                      <Box width="50%">
                        <Typography>
                          <strong>薬局名</strong>
                        </Typography>
                      </Box>
                      <Box width="50%">
                        <Typography>{item.tenantName}</Typography>
                      </Box>
                    </Stack>
                    <Stack direction="row" spacing="2%" alignItems="center">
                      <Box width="50%">
                        <Typography>
                          <strong>受取場所</strong>
                        </Typography>
                      </Box>
                      <Box width="50%">
                        <Typography>{item.locationName}</Typography>
                      </Box>
                    </Stack>
                  </Stack>

                  <IconButton size="large">
                    <KeyboardArrowRightIcon fontSize="large" />
                  </IconButton>
                </Stack>
              ))
            ) : (
              <Box
                sx={{
                  width: "100%",
                  textAlign: "center",
                  paddingTop: "5vh",
                }}
              >
                <Typography variant="h6">薬局ございません。</Typography>
              </Box>
            )}
          </Stack>
        </Paper>
      </Stack>
      <MainColorButton
        label="閉じる"
        onClick={() => closeWindow()}
        style={{ ...bottomButton }}
      />
    </>
  );
};

export default PharmacyList;
